import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import PublicLayout from "@/components/public/PublicLayout";
import AdminLayout from "@/components/admin/AdminLayout";
import AdminLogin, { ProtectedRoute } from "@/pages/admin/AdminLogin";

import Home from "@/pages/Home";
import { AboutUs, History, Origin, Journey } from "@/pages/About";
import { Deities, DeityDetail } from "@/pages/Deities";
import Timings from "@/pages/Timings";
import { SevaCatalogue, SevaDetail } from "@/pages/Seva";
import BookingWizard from "@/pages/BookingWizard";
import BookingLookup from "@/pages/BookingLookup";
import { Events, EventDetail, Utsav } from "@/pages/Events";
import { News, NewsDetail } from "@/pages/News";
import SocialService from "@/pages/SocialService";
import Gallery from "@/pages/Gallery";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import SearchPage from "@/pages/Search";

import Dashboard from "@/pages/admin/Dashboard";
import Bookings from "@/pages/admin/Bookings";
import Refunds from "@/pages/admin/Refunds";
import SevaAdmin from "@/pages/admin/SevaAdmin";
import EventsAdmin from "@/pages/admin/EventsAdmin";
import TimingsAdmin from "@/pages/admin/TimingsAdmin";
import SettingsAdmin from "@/pages/admin/SettingsAdmin";
import Reports from "@/pages/admin/Reports";
import Users from "@/pages/admin/Users";
import AuditLog from "@/pages/admin/AuditLog";
import {
  DeitiesAdmin, JourneyAdmin, SevaCategoriesAdmin, NewsAdmin, AnnouncementsAdmin,
  SocialAdmin, GalleryAdmin, FaqAdmin, LegalAdmin,
} from "@/pages/admin/ContentAdmin";

const P = (el) => <PublicLayout>{el}</PublicLayout>;
const A = (el) => <ProtectedRoute><AdminLayout>{el}</AdminLayout></ProtectedRoute>;

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SettingsProvider>
          <Toaster position="top-center" richColors />
          <Routes>
            {/* Public */}
            <Route path="/" element={P(<Home />)} />
            <Route path="/about" element={P(<AboutUs />)} />
            <Route path="/about/history" element={P(<History />)} />
            <Route path="/about/origin" element={P(<Origin />)} />
            <Route path="/about/journey" element={P(<Journey />)} />
            <Route path="/worship/deities" element={P(<Deities />)} />
            <Route path="/worship/deities/:slug" element={P(<DeityDetail />)} />
            <Route path="/worship/timings" element={P(<Timings />)} />
            <Route path="/seva" element={P(<SevaCatalogue />)} />
            <Route path="/seva/:slug" element={P(<SevaDetail />)} />
            <Route path="/booking" element={P(<BookingWizard />)} />
            <Route path="/booking/lookup" element={P(<BookingLookup />)} />
            <Route path="/happenings/events" element={P(<Events />)} />
            <Route path="/happenings/events/:slug" element={P(<EventDetail />)} />
            <Route path="/happenings/utsav" element={P(<Utsav />)} />
            <Route path="/happenings/news" element={P(<News />)} />
            <Route path="/happenings/news/:slug" element={P(<NewsDetail />)} />
            <Route path="/community/social-service" element={P(<SocialService />)} />
            <Route path="/community/gallery" element={P(<Gallery />)} />
            <Route path="/help/faq" element={P(<FAQ />)} />
            <Route path="/help/contact" element={P(<Contact />)} />
            <Route path="/legal/:slug" element={P(<Legal />)} />
            <Route path="/search" element={P(<SearchPage />)} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={A(<Dashboard />)} />
            <Route path="/admin/bookings" element={A(<Bookings key="bookings" />)} />
            <Route path="/admin/payments" element={A(<Bookings key="payments" paymentMode />)} />
            <Route path="/admin/refunds" element={A(<Refunds />)} />
            <Route path="/admin/reports" element={A(<Reports />)} />
            <Route path="/admin/sevas" element={A(<SevaAdmin />)} />
            <Route path="/admin/seva-categories" element={A(<SevaCategoriesAdmin />)} />
            <Route path="/admin/timings" element={A(<TimingsAdmin />)} />
            <Route path="/admin/deities" element={A(<DeitiesAdmin />)} />
            <Route path="/admin/events" element={A(<EventsAdmin />)} />
            <Route path="/admin/news" element={A(<NewsAdmin />)} />
            <Route path="/admin/announcements" element={A(<AnnouncementsAdmin />)} />
            <Route path="/admin/journey" element={A(<JourneyAdmin />)} />
            <Route path="/admin/social" element={A(<SocialAdmin />)} />
            <Route path="/admin/gallery" element={A(<GalleryAdmin />)} />
            <Route path="/admin/faqs" element={A(<FaqAdmin />)} />
            <Route path="/admin/legal" element={A(<LegalAdmin />)} />
            <Route path="/admin/settings" element={A(<SettingsAdmin />)} />
            <Route path="/admin/users" element={A(<Users />)} />
            <Route path="/admin/audit" element={A(<AuditLog />)} />
          </Routes>
        </SettingsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
